export default "__VITE_ASSET__9ac2061e__"